// eslint-disable-next-line
export default [
	{
		id: 1,
		isChecked: false,
		productName: "juice",
	},
	{
		id: 2,
		isChecked: false,
		productName: "soda",
	},
	{
		id: 3,
		isChecked: false,
		productName: "water",
	},
	{
		id: 4,
		isChecked: false,
		productName: "soft drink",
	},
	// {
	// 	id: 5,
	// 	isChecked: false,
	// 	productName: "smoove",
	// },
	// {
	// 	id: 6,
	// 	isChecked: false,
	// 	productName: "cocktail",
	// },
];
